import { FC } from 'react';
import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

interface TwoColumnLayoutProps {
  listColumns: Array<{ title: string; subtitle: string; list: Array<{ text: string }> }>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      margin: theme.spacing(14, 0, 10),
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(30, 0, 0),
      },
    },
    title: {
      fontWeight: 700,
      fontSize: 32,
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(5),
      [theme.breakpoints.up('md')]: {
        fontSize: 48,
      },
    },
    subtitle: {
      fontWeight: 700,
      fontSize: 16,
      color: `#453737`,
      marginBottom: theme.spacing(5),
      [theme.breakpoints.up('md')]: {
        fontSize: 27,
      },
    },
    text: {
      fontWeight: 500,
      fontSize: 16,
      color: `#453737`,
      [theme.breakpoints.up('md')]: {
        fontSize: 24,
      },
    },
    gridItem: {
      maxWidth: 600,
      marginBottom: 20,
      [theme.breakpoints.up('md')]: {
        marginBottom: 64,
      },
      '&:nth-last-child(-n+2)': {
        marginBottom: 20,
        [theme.breakpoints.up('md')]: {
          marginBottom: 0,
        },
      },
    },
  });
});

const TwoColumnLayout: FC<TwoColumnLayoutProps> = ({ listColumns }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container fixed>
        <Grid container justify={'space-between'}>
          {listColumns.map((item) => {
            const highlightedPart = 'over $885 million';
            const subtitleContainsHighlight = item.subtitle.includes(highlightedPart);
            const subtitleParts = subtitleContainsHighlight ? item.subtitle.split(highlightedPart) : [item.subtitle];

            return (
              <Grid item sm={6} xs={12} key={item.title} className={classes.gridItem}>
                <Typography className={classes.title}>{item.title}</Typography>
                <Typography className={classes.subtitle}>
                  {subtitleContainsHighlight ? (
                    <>
                      {subtitleParts[0]}
                      <Box component="span" color={'primary.main'}>
                        {highlightedPart}
                      </Box>
                      {subtitleParts[1]}
                    </>
                  ) : (
                    item.subtitle
                  )}
                </Typography>
                <ul>
                  {item.list.map((listItem, index) => (
                    <li key={index} className={classes.text}>
                      {listItem.text}
                    </li>
                  ))}
                </ul>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default TwoColumnLayout;
